<img src="{{imageUrl}}" alt="Image" class="img-fluid" *ngIf="imageUrl" />
